import { useContext } from 'react';
import { Button } from '@orbita-ui/core';
import { Col, Row } from 'react-bootstrap';
import { UltimasLiquidacionesContext } from 'core/reporte/contexts/UltimasLiquidacionesContext';
import { UltimasLiquidacionesTable } from '../UltimasLiquidacionesTable/UltimasLiquidacionesTable';

export const UltimasLiquidacionesList = () => {
  const {
    resumenes,
    isTableLoading,
    downloadingKeyValue,
    selectedKeyValues,
    selectionInvalid,
    isBulkDownloading,
    toggleSelection,
    downloadResumen,
    downloadSelected,
  } = useContext(UltimasLiquidacionesContext);

  return (
    <>
      <UltimasLiquidacionesTable
        resumenes={resumenes}
        isLoading={isTableLoading}
        downloadingKeyValue={downloadingKeyValue}
        selectedKeyValues={selectedKeyValues}
        selectionInvalid={selectionInvalid}
        onToggleSelection={toggleSelection}
        onDownloadResumen={downloadResumen}
      />
      {selectionInvalid && (
        <div
          className="invalid-feedback d-block text-end mt-2"
          data-testid="bulk-selection-error"
        >
          Debe seleccionar al menos una liquidacion.
        </div>
      )}
      <Row className="mt-3">
        <Col className="d-flex justify-content-end">
          <Button
            type="button"
            color="primary"
            loading={isBulkDownloading}
            onClick={downloadSelected}
            data-testid="bulk-download-button"
          >
            Descargar liquidaciones seleccionadas
          </Button>
        </Col>
      </Row>
    </>
  );
};
